import ReactDatePicker from 'react-datepicker';

import DatePickerHeader from '../DatePicker/DatePickerHeader';
import { makeYearsArray } from '../DatePicker/utils';
import { DatePickerContainer } from './styled';

type Props = {
  maxDate?: Date;
  dateRange: [Date | null, Date | null];
  onChange: (update: [Date | null, Date | null]) => void;
};

const DateRange = ({ maxDate, dateRange, onChange }: Props): JSX.Element => {
  const [startDate, endDate] = dateRange;

  const handleOnDateRangeChange = (update: [Date | null, Date | null]): void => {
    onChange(update);
  };

  return (
    <DatePickerContainer>
      <ReactDatePicker
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }): JSX.Element => (
          <DatePickerHeader
            date={date}
            changeYear={changeYear}
            changeMonth={changeMonth}
            decreaseMonth={decreaseMonth}
            increaseMonth={increaseMonth}
            prevMonthButtonDisabled={prevMonthButtonDisabled}
            nextMonthButtonDisabled={nextMonthButtonDisabled}
            yearArray={makeYearsArray()}
          />
        )}
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        onChange={handleOnDateRangeChange}
        maxDate={maxDate}
        inline
        isClearable={true}
      />
    </DatePickerContainer>
  );
};

export default DateRange;
